import alt from '../alt';
import filterAction from './filterAction';
import modalAction from './modalAction';

class userSetAction {
    constructor() {
        this.generateActions(
            'usMode',
            'search',
            'warningMsg',
            'staffId',
            'updateUser',
            'userImage',
            'processing',
            'updateSuccess',
            'addSuccess',
            'removeSuccess',
            'isSucceed',
            'userDetailSuccess',
            'updating',
            'updateUserDetail',
            'clear',
            'supervisor',
            'permissionListSuccess',
            'permission',
            'team',
            'removedTeam',
        );
    }


    addNewUser(fd) {
        if (sessionStorage.getItem('ui')) {
            const xhttp = new XMLHttpRequest();
            xhttp.open("POST", '/v1/api/employee/', true);
            xhttp.setRequestHeader("Authorization", "Bearer " + sessionStorage.getItem('ui'));
            xhttp.onreadystatechange = () => {
                if (xhttp.readyState == 4) {
                    let result = JSON.parse(xhttp.responseText);
                    if (xhttp.status == 200) {

                        this.addSuccess(result);
                        filterAction.addSuccess(result);

                        //show success message
                        modalAction.modalContent({ title: "Successful", content: "The employee detail has been added" });
                        modalAction.modalClose(true);
                    } else {
                        //handle error

                        //show error message
                        modalAction.modalContent({ title: "Something Went Wrong", content: result.errorMsg });
                        modalAction.modalClose(true);
                    }
                    this.processing(false);
                }
            };
            xhttp.send(fd);
        }
        return true;
    }
    userDetail(staffId) {

        if (sessionStorage.getItem('ui')) {
            const xhttp = new XMLHttpRequest();
            xhttp.open("GET", '/v1/api/employee/' + staffId, true);
            xhttp.setRequestHeader("Authorization", "Bearer " + sessionStorage.getItem('ui'));
            xhttp.onreadystatechange = () => {
                if (xhttp.readyState == 4) {
                    if (xhttp.status == 200) {
                        let result = JSON.parse(xhttp.responseText);
                        this.userDetailSuccess(result);
                    } else {
                        //handle error
                        //show error message
                        modalAction.modalContent({ title: "Something Went Wrong", content: "Please contact admin" });
                        modalAction.modalClose(true);
                    }
                    this.processing(false);
                }
            };
            xhttp.send(null);
        }

        return true;
    }
    editUser(staffId, fd) {
        if (sessionStorage.getItem('ui')) {
            const xhttp = new XMLHttpRequest();
            xhttp.open("PUT", '/v1/api/employee/' + staffId, true);
            xhttp.setRequestHeader("Authorization", "Bearer " + sessionStorage.getItem('ui'));
            xhttp.onreadystatechange = () => {
                if (xhttp.readyState == 4) {
                    if (xhttp.status == 200) {
                        let result = JSON.parse(xhttp.responseText);
                        this.updateSuccess(result);
                        filterAction.updateSuccess(result);

                        //show success message
                        modalAction.modalContent({ title: "Successful", content: "The employee detail has been updated" });
                        modalAction.modalClose(true);
                    } else {
                        //handle error
                        //show error message
                        modalAction.modalContent({ title: "Something Went Wrong", content: "Please contact admin" });
                        modalAction.modalClose(true);
                    }
                    this.processing(false);
                }

            };
            xhttp.send(fd);
        }
        return true;
    }
    removeUser(staffId) {
        if (sessionStorage.getItem('ui')) {
            const xhttp = new XMLHttpRequest();
            xhttp.open("DELETE", '/v1/api/employee/' + staffId, true);
            xhttp.setRequestHeader("Authorization", "Bearer " + sessionStorage.getItem('ui'));
            xhttp.onreadystatechange = () => {
                if (xhttp.readyState == 4) {

                    if (xhttp.status == 200) {

                        this.removeSuccess(staffId);
                        filterAction.removeSuccess(staffId);

                        //show success message
                        modalAction.modalContent({ title: "Deleted", content: "The employee detail has been removed" });
                        modalAction.modalClose(true);
                    } else {
                        let result = JSON.parse(xhttp.responseText);
                        //handle error
                        //show error message
                        modalAction.modalContent({ title: "Something Went Wrong", content: result.errorMsg });
                        modalAction.modalClose(true);
                    }
                    this.processing(false);
                }

            };
            xhttp.send(null);
        }
        return true;
    }
    getPermissionList() {
        if (sessionStorage.getItem('ui')) {
            const xhttp = new XMLHttpRequest();
            xhttp.open("GET", '/v1/api/permission/list', true);
            xhttp.setRequestHeader("Authorization", "Bearer " + sessionStorage.getItem('ui'));
            xhttp.onreadystatechange = () => {
                if (xhttp.readyState == 4) {
                    if (xhttp.status == 200) {
                        let result = JSON.parse(xhttp.responseText);
                        this.permissionListSuccess(result);
                    } else {
                        //handle error
                        //show error message
                        modalAction.modalContent({ title: "Something Went Wrong", content: "Please contact admin" });
                        modalAction.modalClose(true);
                    }
                    this.processing(false);
                }
            };
            xhttp.send(null);
        }

        return true;
    }
    getTeam() {
        if (sessionStorage.getItem('ui')) {
            const xhttp = new XMLHttpRequest();
            xhttp.open("GET", '/v1/api/team', true);
            xhttp.setRequestHeader("Authorization", "Bearer " + sessionStorage.getItem('ui'));
            xhttp.onreadystatechange = () => {
                if (xhttp.readyState == 4) {
                    if (xhttp.status == 200) {
                        let result = JSON.parse(xhttp.responseText);
                        this.team(result);
                    } else {
                        //handle error
                        //show error message
                        modalAction.modalContent({ title: "Something Went Wrong", content: "Please contact admin" });
                        modalAction.modalClose(true);
                    }
                    this.processing(false);
                }
            };
            xhttp.send(null);
        }

        return true;
    }
    updateTeam(team, removedTeam) {
        if (sessionStorage.getItem('ui')) {
            const xhttp = new XMLHttpRequest();
            xhttp.open("POST", '/v1/api/team', true);
            xhttp.setRequestHeader("Authorization", "Bearer " + sessionStorage.getItem('ui'));
            xhttp.setRequestHeader('Content-Type', 'application/json; charset=UTF-8');
            xhttp.onreadystatechange = () => {
                if (xhttp.readyState == 4) {
                    if (xhttp.status == 200) {
                        modalAction.modalContent({ title: "Successful", content: "Team updated successfully" });
                        modalAction.modalClose(true);
                    } else {
                        //handle error
                        //show error message
                        modalAction.modalContent({ title: "Something Went Wrong", content: "Please contact admin" });
                        modalAction.modalClose(true);
                    }
                    this.processing(false);
                }
            };
            xhttp.send(JSON.stringify({ team: team, removedTeam: removedTeam }));
        }

        return true;
    }
}
export default alt.createActions(userSetAction);


// WEBPACK FOOTER //
// ./app/actions/userSetAction.js